import React from 'react'
import ErrorBoundary from '@dustin-web/microsite-components/src/utils/error-boundary'
import FavoritesMenu from './header-favorites'
import MiniCart from './cart/minicart'
import CompareMenu from './header-compare-menu'
import AccountMenuContainer from './header-account-menu-container'
import AssistiveCart from '@dustin-web/microsite-baselayout/src/components/header/cart/assistive-cart'

const UserNav = () => (
  <ul className="c-header__user-list ul-stripped">
    <ErrorBoundary>
      <AccountMenuContainer />
    </ErrorBoundary>
    <ErrorBoundary>
      <CompareMenu />
    </ErrorBoundary>
    <ErrorBoundary>
      <FavoritesMenu />
    </ErrorBoundary>
    <ErrorBoundary>
      <AssistiveCart />
      <MiniCart />
    </ErrorBoundary>
  </ul>
)

export default UserNav
